import { Component, computed, inject, input } from '@angular/core';
import {
  AttachmentFolderFilterDto,
  AttachmentFolderItemDto,
  AttachmentFolderService,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-attachment-folder-overview-page',
  templateUrl: './attachment-folder-overview-page.component.html',
  styleUrls: ['./attachment-folder-overview-page.component.scss']
})
export class AttachmentFolderOverviewPageComponent {
  attachmentFolderService = inject(AttachmentFolderService);
  currentUserService = inject(CurrentUserService);
  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);

  readonly tenantId = input<string>();

  readonly folderModuleType = input<AttachmentFolderFilterDto.FolderModuleTypeEnum>('BUILDING_DOCUMENTS');

  canCreate = computed(() => this.currentUserService.hasPrivilege('editAttachmentFolders'));

  readonly loadAttachmentFolders = (filter: AttachmentFolderFilterDto) =>
    this.attachmentFolderService.findAll({ ...filter, tenantId: this.tenantId(), folderModuleType: this.folderModuleType() });
  readonly getCount = (filter: AttachmentFolderFilterDto) =>
    this.attachmentFolderService.getCount({ ...filter, tenantId: this.tenantId(), folderModuleType: this.folderModuleType() });

  readonly form: FormGroup = this.formBuilder.group({
    text: this.formBuilder.control(''),
  });

  navigateToRegion(region: AttachmentFolderItemDto): void {
    this.router.navigate(['attachmentFolder', region.id], {
      queryParams: { tenantId: this.tenantId(), folderModuleType: this.folderModuleType() },
    });
  }

  add(): void {
    this.router.navigate(['attachmentFolder', 'new'], {
      queryParams: { tenantId: this.tenantId(), folderModuleType: this.folderModuleType() },
    });
  }
}
